import './App.css';
import Header from './components/header/Header'
import Greeting from './components/greeting/Greeting'
import Contact from './components/contact/Contact'
import Education from './components/education/education'
import Footer from './components/footer/Footer'
import Top from './components/topbutton/Top'
import Skills from './components/skills/Skills'
import Project from './components/projects/Projects'


function App() {
 return <>
 <Header></Header>
 <Greeting></Greeting>
 <Education></Education>
 <Skills></Skills>
 <Project></Project>
 <Contact></Contact>
 <Footer></Footer>
 <Top></Top>

 
 
 </>
}

export default App;
